module.exports = __webpack_public_path__ + "static/media/space-ship.a7eb3c92.png";